import React from 'react';
import { Button } from './Button';
export function FinalCTASection() {
  return <section className="py-20 bg-brand-dark text-white px-4 text-center" data-id="element-66">
      <div className="max-w-4xl mx-auto" data-id="element-67">
        <h2 className="text-4xl md:text-5xl font-black mb-8" data-id="element-68">
          No dejes que tu competencia automatice primero.
        </h2>
        <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-69">
          El mercado está cambiando. Los que dominan la IA y la automatización
          se llevan a los mejores clientes. ¿De qué lado vas a estar?
        </p>
        <Button href="#compra" size="xl" className="animate-bounce-slow" data-id="element-70">
          Sí, Quiero la Saga Completa + 80 Blueprints
        </Button>
        <p className="mt-6 text-gray-400 text-sm" data-id="element-71">
          Garantía de satisfacción. Acceso inmediato tras el pago.
        </p>
      </div>
    </section>;
}